<template>
    <section class="welcome-banner">
        <div class="cto-container">
            <div class="page-container">
                <div class="cto-details-box">
                    <div class="logo-box">
                        <figure class="logo">
                            <a href="/">
                                <img src="/images/new.svg" alt="Ulta">
                            </a>
                        </figure>
                    </div>
                    <div class="welcome-copy">
                        <figure class="featured mb-30">
                            <img class="ulta_cc w-25" src="images/single_card.png" alt="">
                        </figure>
                        <h1 class="txt-black mb-30" >Beyond Ulta Beauty Rewards<sup>&#8482;</sup></h1>
                        <p class="txt-black mb-30" >More shopping, more points—more joy.</p>
                        <p class="txt-black" >
                            Earn more points, cash back and super rewardy<sup>&#8482;</sup> deals on your favorite brands with the Beyond Ulta Beauty Rewards™ Program this holiday season.
                        </p>

                    </div>
                </div>
                <div class="cto-card">
                    <p class="text-h6">Earn</p>
                    <p class="text-h1 mt-20">100</p>
                    <p class="text-h2 mt-20">Bonus Points<sup>*</sup></p>
                    <p class="text-h6 cto-card-message mt-20">when you enroll now through December 31</p>
                </div>

            </div>
        </div>

        <div class="page-container bg-white auth-actions-box">
                <div v-if="$route.name!=='register'">
                    <button type="button" v-on:click="openRegister" class="button pink midsize caps wide me-3">Register</button>
                    <button type="button" v-on:click="openSignIn" class="button transparent midsize caps wide pink_sign_in">Sign In </button>
                </div>
        </div>

    </section>
</template>

<script>

import LandingPageOfferComponent from '../LandingPageOfferComponent.vue';
import LogoComponent from "../LogoComponent.vue";

export default {

    name: "WelcomeBannerPromotion",
    components: {
        LogoComponent,
        LandingPageOfferComponent
    },
    props: ['offer'],
    methods: {
        openSignIn: function () {
            this.$router.push('sign_in')
        },
        openRegister: function () {
            this.$router.push('register')
        },
    }
}
</script>
<style scoped>
    @media (max-width: 850px) {
        .page-container {
            flex-direction: column;
        }
        .cto-details-box {
            width: 100% !important;
        }
        .cto-container {
            padding-bottom: 50px;
        }
        .cto-details-box {
            align-self: flex-start;
        }
    }
    .welcome-banner {
        padding: 0;
    }
    .cto-container {
        background-color: #FBD2E1;
        padding-top: 100px;
        .cto-details-box {
            width: 50%;
        }
        .welcome-copy {
            padding:30px 0;
        }
        .logo-box {
            background-color: white;
            display: inline-block;
            padding: 10px;
            width: inherit;
        }
        .logo {
            width:auto;
            img {
                width:100%;
                max-width: 330px;
            }
        }
        .welcome-copy {
            width: 100%;
            p,h1 {
                font-size: 28px;
                color: black;
            }
        }
        .cto-card {
            max-width: 90%;
            width: 600px;
            padding: 25px 20px;
            background-color: white;
            border-radius: 30px;
            text-align: center;

            p {
                line-height: 1;
            }
            .cto-card-message {
                max-width: 398px;
                margin-left: auto;
                margin-right: auto;
            }

            .text-h6 {
                font-size: 28px;
            }
            .text-h1 {
                font-weight: 700;
                font-size: 144px;
                color: #E90B5A;

            }
            .text-h2 {
                color: black;
                font-weight: 700;
                font-size: 64px;
                color: #E90B5A;
            }
        }
    }
    .auth-actions-box {
        padding : 60px 0;
        .pink_sign_in {
            color: #E90B5A;
        }
    }

</style>

